export const Products_data = [
  {
    id: 1,
    image_url:
      "https://onemg.gumlet.io/image/upload/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/v1613051006/gkuqf76bodwm9fvowxi4.jpg",
    name: "Bhumija Lifesciences Lifefiz Garlic Effervescent Tablet Lemon",
    desc: "bottle of 20 Effervescent Tablet",
    mrp: 475,
    price: 388,
    discount: "18% off",
  },
  {
    id: 2,
    image_url:
      "https://onemg.gumlet.io/image/upload/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/v1626179581/hvblqyl499yyog0xeo5e.jpg",
    name: "CMG Nutritions CgMuneshield Capsule To Maintain Healthy Immune System",
    desc: "bottle of 60 capsules",
    mrp: 1201,
    price: 999,
    discount: "16% off",
  },
  {
    id: 3,
    image_url:
      "https://onemg.gumlet.io/image/upload/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/v1603457528/lsnxasjdu0xc2nfl2mcn.jpg",
    name: "Geo Fresh Organic Moringa 500mg Tablet",
    desc: "bottle of 90 tablets",
    mrp: 225,
    price: 218,
    discount: "3% off",
  },
  {
    id: 4,
    image_url:
      "https://onemg.gumlet.io/image/upload/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/v1603178650/cx0fq068c2eco9qovfds.jpg",
    name: "Neuherbs Triple Tulsi-Giloy+ Tablet",
    desc: "bottle of 60 tablets",
    mrp: 599,
    price: 569.05,
    discount: "5% off",
  },
  {
    id: 5,
    image_url:
      "https://onemg.gumlet.io/image/upload/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/v1631168317/rbrysnbi551hxmqwbbic.jpg",
    name: "Bakson's Ginseng Plus Capsule",
    desc: "bottle of 30 capsules",
    mrp: 320,
    price: 313.6,
    discount: "2% off",
  },
  {
    id: 6,
    image_url:
      "https://onemg.gumlet.io/image/upload/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/v1650266403/jc7vfexwuz4z7cqbdmnr.jpg",
    name: "Organic India Giloy (Tinospora Cordifolia) Veg Capsule",
    desc: "bottle of 60 vegicaps",
    mrp: 225,
    price: 218,
    discount: "3% off",
  },
  {
    id: 7,
    image_url:
      "https://onemg.gumlet.io/image/upload/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/v1627280691/bdpn8kahfcjxxkbdcrud.jpg",
    name: "Fitday Ginger Licorice & Tulsi Cold & Flu Herbal Gummies Orange",
    desc: "bottle of 150 gm Gummy",
    mrp: 499,
    price: 408,
    discount: "18% off",
  },
  {
    id: 8,
    image_url:
      "https://onemg.gumlet.io/image/upload/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/v1646614837/qnqamtf4x16j3rjjytmz.jpg",
    name: "Ayurvedic Life Moringa Tablet",
    desc: "bottle of 700 tablets",
    mrp: 1570,
    price: 1319,
    discount: "16% off",
  },
  {
    id: 9,
    image_url:
      "https://onemg.gumlet.io/image/upload/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/v1627562099/kmjy4bb4meiqickl2wub.jpg",
    name: "Giosun Spirulina 1000mg Tablet",
    desc: "bottle of 60 tablets",
    mrp: 792,
    price: 630,
    discount: "20% off",
  },
];
